import { __rest } from "tslib";
import React, { useState, useCallback } from 'react';
import Input from './Input';
import { string } from 'prop-types';
import { TertiaryButton } from '../Button';
import { ShowIcon, HideIcon } from '../../assets/svgs';
import './PasswordInput.less';
export default function PasswordInput(_a) {
    var { buttonLabelShow = 'Show', buttonLabelHide = 'Hide' } = _a, props = __rest(_a, ["buttonLabelShow", "buttonLabelHide"]);
    const [showContent, setShowContent] = useState(false);
    const handleToggleShow = useCallback(() => {
        setShowContent((current) => !current);
    }, []);
    return (React.createElement("div", { className: 'kal-password-input-container' },
        React.createElement(Input, Object.assign({ type: showContent ? 'text' : 'password' }, props)),
        React.createElement(TertiaryButton, { className: 'show-hide-button', onClick: handleToggleShow, iconStart: showContent ? React.createElement(HideIcon, { "aria-hidden": true }) : React.createElement(ShowIcon, { "aria-hidden": true }), lowProfile: true, "aria-controls": props.id }, showContent ? buttonLabelHide : buttonLabelShow)));
}
PasswordInput.propTypes = {
    id: string,
    buttonLabelShow: string,
    buttonLabelHide: string,
};
//# sourceMappingURL=PasswordInput.js.map